<template>
  <div
    class="thumbnail-uploader"
    :class="{ 'thumbnail-uploader--error': error }"
  >
    <div class="file has-name is-boxed">
      <label class="file-label">
        <input
          class="file-input"
          type="file"
          name="resume"
          accept="image/*"
          @change="updateFile"
          :disabled="submitting"
          @focus="$emit('focus')"
          @blur="$emit('blur')"
        />
        <figure class="image">
          <img ref="preview" />
          <div class="image-cover loading" v-if="submitting">
            <div
              class="spinner is-3by4 is-centered is-grey-lighter is-medium is-normal"
            />
          </div>

          <div
            class="image-cover prompt"
            :class="{ 'prompt--selected-file': selectedFile || src }"
            v-else
          >
            <div class="image-label">
              <p>
                <icon name="fa-upload" />
              </p>
              <p>Wybierz plik z miniaturką filmu...</p>
            </div>
          </div>
        </figure>
      </label>
    </div>
    <span class="error" v-if="error">{{ error }}</span>
  </div>
</template>

<script>
import { Icon } from "%helpers";

export default {
  name: "thumbnail-uploader",

  components: {
    Icon
  },

  props: {
    uploadFunction: Function,
    error: String,
    value: String,
    url: String
  },

  data() {
    return {
      selectedFile: false,
      submitting: false,
      src: undefined
    };
  },

  methods: {
    updateFile(input) {
      if (!this.submitting && input.target.files && input.target.files[0]) {
        this.submitting = true;
        const file = input.target.files[0];
        this.uploadFunction(file)
          .then(response => this.$emit("input", response.data.fileName))
          .then(() => this.updatePreview(file))
          .finally(() => (this.submitting = false));
      }
    },

    updatePreview(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.src = e.target.result;
        this.selectedFile = true;
      };
      reader.readAsDataURL(file);
    }
  },

  beforeMount() {
    if (this.value) {
      this.src = this.url + this.value;
    }
  },

  watch: {
    value(value) {
      this.src = this.url + value;
    },

    src(value) {
      this.$refs.preview.src = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.thumbnail-uploader {
  margin-bottom: 1rem;

  .file-label {
    width: 100%;

    .image {
      border: solid 1px $grey-lighter;
      border-radius: $radius;
      color: $grey-lighter;
      min-height: 10rem;

      position: relative;

      &-cover {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }

      .prompt {
        .label {
          text-align: center;

          .icon {
            font-size: 3rem;
          }
        }

        &--selected-file {
          background: $black;
          color: $white;
          opacity: 0;
          transition: 0.3s;

          &:hover {
            opacity: 0.8;
            transition: 0.3s;
          }
        }
      }

      &:hover {
        border-color: $grey-light;
        color: $grey-light;
      }
    }
  }

  &.thumbnail-uploader--error {
    .file-label {
      .image {
        border-color: $danger;

        &:hover {
          border-color: $danger;
        }
      }
    }

    .error {
      font-size: 0.75rem;
      color: $danger;
    }
  }
}
</style>
